"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.rawOperationsToOperations = exports.addressExists = exports.isAddressValid = exports.isAccountMultiSign = exports.isMemoValid = exports.checkRecipientExist = exports.formatOperation = exports.getOperationType = exports.getAccountSpendableBalance = void 0;
var bignumber_js_1 = require("bignumber.js");
var stellar_sdk_1 = __importDefault(require("stellar-sdk"));
var cache_1 = require("../../cache");
var api_1 = require("./api");
var currencies_1 = require("../../currencies");
var operation_1 = require("../../operation");
var currency = (0, currencies_1.getCryptoCurrencyById)("stellar");
var getMinimumBalance = function (account) {
    var baseReserve = 0.5;
    var numberOfEntries = account.subentry_count;
    var minimumBalance = (2 + numberOfEntries) * baseReserve;
    return (0, currencies_1.parseCurrencyUnit)(currency.units[0], minimumBalance.toString());
};
var getAccountSpendableBalance = function (balance, account) { return __awaiter(void 0, void 0, void 0, function () {
    var minimumBalance, baseFee;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                minimumBalance = getMinimumBalance(account);
                return [4 /*yield*/, (0, api_1.fetchBaseFee)()];
            case 1:
                baseFee = _a.sent();
                return [2 /*return*/, bignumber_js_1.BigNumber.max(balance.minus(minimumBalance).minus(baseFee), 0)];
        }
    });
}); };
exports.getAccountSpendableBalance = getAccountSpendableBalance;
var getOperationType = function (operation, addr) {
    switch (operation.type) {
        case "create_account":
            return operation.funder === addr ? "OUT" : "IN";
        case "payment":
            if (operation.from === addr && operation.to !== addr) {
                return "OUT";
            }
            return "IN";
        case "path_payment_strict_send":
            return "OUT";
        case "path_payment_strict_receive":
            return "IN";
        default:
            if (operation.source_account === addr) {
                return "OUT";
            }
            return "IN";
    }
};
exports.getOperationType = getOperationType;
var getRecipients = function (operation) {
    switch (operation.type) {
        case "create_account":
            return [operation.account];
        case "payment":
            return [operation.to];
        default:
            return [];
    }
};
var formatOperation = function (rawOperation, accountId, addr) { return __awaiter(void 0, void 0, void 0, function () {
    var transaction, type, value, recipients, memo, operation;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, rawOperation.transaction()];
            case 1:
                transaction = _a.sent();
                type = (0, exports.getOperationType)(rawOperation, addr);
                value = getValue(rawOperation, transaction, type);
                recipients = getRecipients(rawOperation);
                memo = transaction.memo
                    ? transaction.memo_type === "hash" || transaction.memo_type === "return"
                        ? Buffer.from(transaction.memo, "base64").toString("hex")
                        : transaction.memo
                    : null;
                operation = {
                    id: (0, operation_1.encodeOperationId)(accountId, rawOperation.transaction_hash, type),
                    accountId: accountId,
                    fee: new bignumber_js_1.BigNumber(transaction.fee_charged),
                    value: value,
                    type: type,
                    hash: rawOperation.transaction_hash,
                    blockHeight: transaction.ledger_attr,
                    date: new Date(rawOperation.created_at),
                    senders: [rawOperation.source_account],
                    recipients: recipients,
                    transactionSequenceNumber: Number(transaction.source_account_sequence),
                    // @ts-expect-error check transaction_successful property
                    hasFailed: !rawOperation.transaction_successful,
                    blockHash: null,
                    extra: memo
                        ? {
                            memo: memo
                        }
                        : {}
                };
                return [2 /*return*/, operation];
        }
    });
}); };
exports.formatOperation = formatOperation;
var getValue = function (operation, transaction, type) {
    var value = new bignumber_js_1.BigNumber(0);
    // @ts-expect-error check transaction_successful property
    if (!operation.transaction_successful) {
        return type === "IN" ? value : new bignumber_js_1.BigNumber(transaction.fee_charged || 0);
    }
    switch (operation.type) {
        case "create_account":
            value = (0, currencies_1.parseCurrencyUnit)(currency.units[0], operation.starting_balance);
            if (type === "OUT") {
                value = value.plus(transaction.fee_charged);
            }
            return value;
        case "payment":
        case "path_payment_strict_send":
        case "path_payment_strict_receive":
            value =
                operation.asset_type === "native"
                    ? (0, currencies_1.parseCurrencyUnit)(currency.units[0], operation.amount)
                    : new bignumber_js_1.BigNumber(0);
            if (type === "OUT") {
                value = value.plus(transaction.fee_charged);
            }
            return value;
        default:
            return type !== "IN" ? new bignumber_js_1.BigNumber(transaction.fee_charged) : value;
    }
};
// TODO: Move to cache.js
exports.checkRecipientExist = (0, cache_1.makeLRUCache)(function (_a) {
    var recipient = _a.recipient;
    return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, (0, exports.addressExists)(recipient)];
            case 1: return [2 /*return*/, _b.sent()];
        }
    }); });
}, function (extract) { return extract.recipient; }, {
    max: 300,
    maxAge: 5 * 60
} // 5 minutes
);
var isMemoValid = function (memoType, memoValue) {
    switch (memoType) {
        case "MEMO_TEXT":
            if (memoValue.length > 28) {
                return false;
            }
            break;
        case "MEMO_ID":
            if (new bignumber_js_1.BigNumber(memoValue.toString()).isNaN()) {
                return false;
            }
            break;
        case "MEMO_HASH":
        case "MEMO_RETURN":
            if (!memoValue.length || memoValue.length !== 64) {
                return false;
            }
            break;
    }
    return true;
};
exports.isMemoValid = isMemoValid;
var isAccountMultiSign = function (account) { return __awaiter(void 0, void 0, void 0, function () {
    var signers;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, api_1.fetchSigners)(account)];
            case 1:
                signers = _a.sent();
                return [2 /*return*/, signers.length > 1];
        }
    });
}); };
exports.isAccountMultiSign = isAccountMultiSign;
/**
 * Returns true if address is valid, false if it's invalid (can't parse or wrong checksum)
 *
 * @param {*} address
 */
var isAddressValid = function (address) {
    if (!address)
        return false;
    try {
        return stellar_sdk_1["default"].StrKey.isValidEd25519PublicKey(address);
    }
    catch (err) {
        return false;
    }
};
exports.isAddressValid = isAddressValid;
/**
 * Checks if the current account exists on the stellar Network. If it doesn't the account needs
 * to be activated by sending an account creation operation with an amount of at least the base reserve.
 *
 * @param {*} address
 */
var addressExists = function (address) { return __awaiter(void 0, void 0, void 0, function () {
    var account;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, (0, api_1.loadAccount)(address)];
            case 1:
                account = _a.sent();
                return [2 /*return*/, !!account];
        }
    });
}); };
exports.addressExists = addressExists;
var rawOperationsToOperations = function (operations, addr, accountId) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        return [2 /*return*/, Promise.all(operations
                .filter(function (operation) {
                return (
                // @ts-expect-error check from property
                operation.from === addr ||
                    // @ts-expect-error check to property
                    operation.to === addr ||
                    // @ts-expect-error check funder property
                    operation.funder === addr ||
                    // @ts-expect-error check account property
                    operation.account === addr ||
                    operation.source_account === addr);
            })
                .map(function (operation) { return (0, exports.formatOperation)(operation, accountId, addr); }))];
    });
}); };
exports.rawOperationsToOperations = rawOperationsToOperations;
//# sourceMappingURL=logic.js.map